import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import {
  deleteMarginRecord,
  clearMarginMessages,
} from "../../../store/marginManagement/marginSlice";

const DeleteConfirmationDialog = ({ open, onClose, record }) => {
  const dispatch = useDispatch();
  const { isDeletingMarginRecord } = useSelector((state) => state.margin);

  const handleConfirmDelete = () => {
    if (record?.id) {
      dispatch(deleteMarginRecord(record.id));
    }
  };

  const handleClose = () => {
    if (!isDeletingMarginRecord) {
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ bgcolor: "#f3f4f6", borderBottom: "1px solid #ddd" }}>
        <Typography variant="h6" component="h2">
          Confirm Delete
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Are you sure you want to delete the margin record "{record?.name}"?
        </Typography>
        <Typography variant="body2" color="textSecondary">
          This action cannot be undone. The margin record will be permanently
          removed and the existing FinOps data might be affected.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button
          variant="outlined"
          onClick={handleClose}
          disabled={isDeletingMarginRecord}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleConfirmDelete}
          disabled={isDeletingMarginRecord}
          sx={{
            backgroundColor: "#d32f2f",
            "&:hover": {
              backgroundColor: "#b71c1c",
            },
          }}
        >
          {isDeletingMarginRecord && (
            <CircularProgress size={20} sx={{ mr: 1, color: "white" }} />
          )}
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
